module.exports = __webpack_public_path__ + "media/84.5b9dc84d.mp3";